module.exports = __webpack_public_path__ + "static/media/scaling.f07171ce.gif";